import { __assign, __extends } from "tslib";
import { omit } from '@antv/util';
import GroupComponent from '../abstract/group-component';
import { DEFAULT_HANDLER_HEIGHT, DEFAULT_HANDLER_WIDTH, HANDLER_STYLE } from './constant';
var Handler = /** @class */ (function (_super) {
    __extends(Handler, _super);
    function Handler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Handler.prototype.getDefaultCfg = function () {
        var cfg = _super.prototype.getDefaultCfg.call(this);
        return __assign(__assign({}, cfg), { name: 'handler', x: 0, y: 0, width: DEFAULT_HANDLER_WIDTH, height: DEFAULT_HANDLER_HEIGHT, style: HANDLER_STYLE });
    };
    Handler.prototype.renderInner = function (group) {
        var _a = this.cfg, width = _a.width, height = _a.height, style = _a.style, sliderHeight = _a.sliderHeight;
        var stroke = style.stroke, cursor = style.cursor;
        // 滑块柄竖线
        this.addShape(group, {
            type: 'line',
            id: this.getElementId('background-line'),
            attrs: {
                x1: (1 / 2) * width,
                y1: -(sliderHeight - height) / 2,
                x2: (1 / 2) * width,
                y2: (height + sliderHeight) / 2,
                stroke: stroke,
            },
        });
        // 滑块柄框框
        this.addShape(group, {
            type: 'rect',
            id: this.getElementId('background'),
            attrs: __assign({ x: 0, y: 0, width: width,
                height: height }, omit(style, ['stroke'])),
        });
        // 两根竖线
        var x1 = (1 / 3) * width;
        var x2 = (2 / 3) * width;
        var y1 = (1 / 4) * height;
        var y2 = (3 / 4) * height;
        this.addShape(group, {
            id: this.getElementId('line-left'),
            name: 'handler-line',
            type: 'line',
            attrs: {
                x1: x1,
                y1: y1,
                x2: x1,
                y2: y2,
                stroke: stroke,
                cursor: cursor,
            },
        });
        this.addShape(group, {
            id: this.getElementId('line-right'),
            name: 'handler-line',
            type: 'line',
            attrs: {
                x1: x2,
                y1: y1,
                x2: x2,
                y2: y2,
                stroke: stroke,
                cursor: cursor,
            },
        });
    };
    Handler.prototype.applyOffset = function () {
        this.moveElementTo(this.get('group'), {
            x: this.get('x'),
            y: this.get('y'),
        });
    };
    Handler.prototype.initEvent = function () {
        this.bindEvents();
    };
    Handler.prototype.bindEvents = function () {
        var _this = this;
        this.get('group').on('mouseenter', function () {
            var highLightStroke = _this.get('style').highLightStroke;
            _this.getElementByLocalId('background-line').attr('stroke', highLightStroke);
            _this.getElementByLocalId('line-left').attr('stroke', highLightStroke);
            _this.getElementByLocalId('line-right').attr('stroke', highLightStroke);
            _this.draw();
        });
        this.get('group').on('mouseleave', function () {
            var stroke = _this.get('style').stroke;
            _this.getElementByLocalId('background-line').attr('stroke', stroke);
            _this.getElementByLocalId('line-left').attr('stroke', stroke);
            _this.getElementByLocalId('line-right').attr('stroke', stroke);
            _this.draw();
        });
    };
    Handler.prototype.draw = function () {
        var canvas = this.get('container').get('canvas');
        if (canvas) {
            canvas.draw();
        }
    };
    return Handler;
}(GroupComponent));
export { Handler };
export default Handler;
//# sourceMappingURL=handler.js.map